var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "failed__Property 1=Failed",
    className: "failed__Property failed__1=Failed"
  }, /*#__PURE__*/React.createElement("path", {
    id: "failed__Subtract",
    fill: "#F00707",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 1 1 .001 14.001A7 7 0 0 1 8 1Zm2.652 4.349a.751.751 0 0 0-1.004-.052l-.057.052L8 6.939l-1.59-1.59-.057-.052a.75.75 0 0 0-1.056 1.056l.052.056L6.939 8 5.35 9.592a.75.75 0 0 0-.053 1.003.437.437 0 0 0 .21.175.748.748 0 0 0 .903-.118L8 9.061l1.59 1.591a.748.748 0 0 0 .902.118.436.436 0 0 0 .211-.176.75.75 0 0 0-.05-1.003L9.06 8l1.591-1.59a.75.75 0 0 0 0-1.061Z",
    className: "failed__Subtract",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a3482c96ef22ab2d513cd273f8b9d5e8.svg";
export { ForwardRef as ReactComponent };